<template>
  <div>
    <form>
      <v-layout wrap>
        <v-flex xs12 sm6>
          <div class="form-control" :class="{ 'has-error': errors.has('photo') }">
            <label>{{ $t('photo') }}</label>
            <uploadfile
              name="photo"
              :data-vv-as="$t('photo')"
              v-model="data.image_url"
              :height="150"
              :backGroundAuto="true"
            ></uploadfile>
            <span class="text-error" v-if="errors.has('photo')">{{ errors.first('photo') }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <div class="form-control pa-1 mt-1" :class="{ 'has-error': errors.has(`name`) }">
            <label>{{ $t('booking_name') }}</label>
            <input
              :data-vv-as="$t('booking_name')"
              v-model="data.booking_name"
              v-validate="'required'"
              :name="`name`"
              class="form-control mr-3"
              type="text"
            />
            <span class="text-error" v-if="errors.has(`name`)">{{ errors.first(`name`) }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <div class="form-control pa-1" :class="{ 'has-error': errors.has('google_calendar_id') }">
            <label>{{ $t('Google Calendar ID') }} </label>
            <input
              :data-vv-as="$t('Google Calendar ID')"
              v-model="data.google_calendar_id"
              v-validate="'required'"
              name="google_calendar_id"
              class="form-control"
              type="text"
            />
            <span class="text-error" v-if="errors.has('google_calendar_id')">{{
              errors.first('google_calendar_id')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <div
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('booking_description') }"
          >
            <label>{{ $t('Description') }}</label>
            <input
              :data-vv-as="$t('Description')"
              v-model="data.booking_description"
              v-validate="'required'"
              name="booking_description"
              class="form-control"
              type="text"
            />
            <span class="text-error" v-if="errors.has('booking_description')">{{
              errors.first('booking_description')
            }}</span>
          </div>
        </v-flex>
      </v-layout>
    </form>
    <div class="text-xs-center">
      <v-btn outline color="grey" :loading="loading" @click="closeEdit">{{ $t('cancel') }}</v-btn>
      <v-btn depressed color="primary" :loading="loading" @click="submitFrom">{{
        $t('Save')
      }}</v-btn>
    </div>
  </div>
</template>

<script>
import uploadfile from '@/components/elements/uploadfile'
export default {
  props: ['value', 'isShow', 'loading'],
  data() {
    return {
      data: this.value
    }
  },
  components: { uploadfile },
  methods: {
    closeEdit() {
      const vm = this
      vm.$emit('update:isShow', false)
    },
    async submitFrom() {
      const vm = this
      let result = await vm.$validator.validateAll()
      if (result) {
        vm.$emit('submit')
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/calendar/BookingForm.vue